import { render } from "./LastCommentView.vue?vue&type=template&id=d20b927e&ts=true"
import script from "./LastCommentView.vue?vue&type=script&lang=ts"
export * from "./LastCommentView.vue?vue&type=script&lang=ts"

import "./LastCommentView.vue?vue&type=style&index=0&id=d20b927e&lang=css"

import exportComponent from "C:\\Users\\AloneX\\taipeitest\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__